import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { ICellRendererParams } from '@ag-grid-community/core';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import dayjs from 'dayjs';
import { BehaviorSubject } from 'rxjs';

import { BadgeComponent } from '@shared/components/badge/badge.component';
import { IconComponent } from '@shared/components/icon/icon.component';
import { TooltipDirective } from '@shared/directives/tooltip.directive';

import { DistributionTimelineService } from '../../services/distribution-timeline.service';

export interface AgMonthCellComponentParams extends ICellRendererParams {
  currentOpenMonth$?: BehaviorSubject<string>;
  noMonthInTimelineTooltipMessage: string;
  timeline$: BehaviorSubject<{ endDate?: string; startDate?: string }>;
}

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TooltipDirective, IconComponent, BadgeComponent],
  template: `
    <div class="flex items-center">
      @if (isMonthNoLongerInTimeline) {
        <aux-icon
          name="AlertTriangle"
          class="mr-2 text-aux-red-dark"
          [auxTooltip]="params.noMonthInTimelineTooltipMessage"
        />
      }
      <span>{{ value }}</span>
      @if (shouldDisplayOpenMonthBadge) {
        <aux-badge title="OPEN MONTH" variant="blue" />
      }
    </div>
  `,
})
export class AgMonthCellComponent implements ICellRendererAngularComp {
  cellClass!: string;
  isMonthNoLongerInTimeline = false;
  params!: AgMonthCellComponentParams;
  value!: string;

  agInit(params: AgMonthCellComponentParams) {
    this.params = params;

    const cellValue = this.params.valueFormatted || this.params.value;

    this.value = cellValue;

    this.isMonthNoLongerInTimeline = DistributionTimelineService.isMonthNoLongerInTimeline(
      params,
      this.params.value,
      this.params.timeline$
    );
  }

  refresh() {
    return false;
  }

  get shouldDisplayOpenMonthBadge(): boolean {
    if (!this.params?.currentOpenMonth$?.value) {
      return false;
    }

    return (
      dayjs(this.params.currentOpenMonth$.value).format('YYYY-MM') ===
      dayjs(this.params.value).format('YYYY-MM')
    );
  }
}
